// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1QGWud6GCilhrTtOh9o19q"};